define(["require", "exports", "jquery", "./context", "./addressBar", "./analytics", "./ajaxCart", "./assetPicker", "./notifications", "./number", "./renderCustomValance", "./settings"], function (require, exports, $, context_1, addressBar_1, analytics_1, ajaxCart_1, assetPicker_1, notifications_1, number_1, renderCustomValance_1, settings_1) {
    "use strict";
    exports.__esModule = true;
    function displayField(data, field) {
        if (data[field] !== undefined) {
            if (field.endsWith('Cost') || field.endsWith('Original') || field.endsWith('Price')) {
                var price = +data[field];
                if (!isNaN(price)) {
                    return '$' + Math.floor(price).toFixed(0);
                }
                return '$' + data[field];
            }
            else if (field.endsWith('Height') || field.endsWith('Width')) {
                return data[field] + '"';
            }
        }
        return "" + data[field];
    }
    function originalPrice(pricing, key) {
        if (key === 'totalProductCost') {
            return pricing['fullSetOriginal'];
        }
        var prefixLength = key.indexOf('Cost');
        if (prefixLength > 0 && prefixLength + 4 === key.length) {
            return pricing[key.substr(0, prefixLength) + "Original"];
        }
    }
    function showPricingFromFormula(pricing) {
        for (var key in pricing) {
            $('#' + key + ' .offer-price').text(displayField(pricing, key));
            $('span#' + key).text(displayField(pricing, key));
            $('input[data-informational-name="' + key + '"]').val(pricing[key]);
            if (key === 'panelWidth') {
                number_1.setFieldNumberVal($('input[type="hidden"]#panelWidth'), pricing[key]);
            }
        }
        if (context_1["default"].isMobile()) {
            var $cur = $('.product-price-sheet.select .option.selected');
            var key = $cur.find('[id]').attr('id');
            if (key) {
                var oldPrice = originalPrice(pricing, key);
                var specialPriceSaving = oldPrice > 0 ? ((oldPrice - pricing[key]) / oldPrice * 100).toFixed(0) : 0.0;
                if (specialPriceSaving > 0) {
                    var savings = $('.price-sheet-current #specialPriceSaving');
                    if (savings.length === 0) {
                        var $anchor = $('.price-sheet-current .price-infos');
                        $("<span class=\"specialPriceSaving\">(<span id=\"specialPriceSaving\">" + specialPriceSaving + "%</span> off)</span>").appendTo($anchor);
                    }
                    else {
                        savings.text(specialPriceSaving + "%");
                    }
                }
                var discountPricing = exports.computeDiscountedPricing(pricing);
                if (discountPricing !== pricing) {
                    $('#primary-discounted-price').text(" $" + discountPricing[key].toFixed(0));
                }
                else {
                    $('.specialPriceSaving').toggleClass('final-price', true);
                    $('.price-sheet-current .offer-price').toggleClass('final-price', true);
                }
            }
            $('.price-sheet-current .msrp').text($cur.find('.msrp').text());
            $('.price-sheet-current .offer-price').text($cur.find('.offer-price').text());
        }
    }
    var _computeDiscountedPricing = null;
    exports.computeDiscountedPricing = function (pricing) { return _computeDiscountedPricing ? _computeDiscountedPricing(pricing) : pricing; };
    function setDiscountPercentage(discount) {
        _computeDiscountedPricing = function (pricing) {
            var result = {};
            if (discount > 0) {
                $.each(pricing, function (key, v) {
                    if (key.endsWith('Cost')) {
                        result[key] = v * (1 - discount);
                    }
                    else {
                        result[key] = v;
                    }
                });
                return result;
            }
            return pricing;
        };
    }
    exports.setDiscountPercentage = setDiscountPercentage;
    exports.dummyFabric2Parts = {
        fabric2_for_swags: 0,
        fabric2_for_fans: 0,
        fabric2_for_pelmet: 0,
        fabric2_for_rodPocket: 0,
        fabric2_for_sideTails: 0,
        fabric2_for_midTails: 0,
        fabric2_for_drapes: 0
    };
    var windowMeasurementAttrs = ['windowWidth', 'windowHeight', 'windowLeftMargin', 'windowRightMargin', 'windowTopMargin', 'windowBottomMargin'];
    function getAttributesFromForm(forRendering, productType) {
        var data = {};
        $('.attributes select[data-attribute-id]').each(function (i, s) {
            var $select = $(s);
            var $selected = $select.find('option:selected');
            var selectedValue = $selected.text();
            var decimalVal = parseFloat(selectedValue);
            if (isNaN(decimalVal)) {
                decimalVal = $selected.data('decimal');
            }
            data[$select.data('attribute-name')] = decimalVal;
        });
        $('.attributes input[data-attribute-id]').each(function (i, h) {
            var $hidden = $(h);
            if ($hidden.attr("type") == "radio") {
                if ($hidden.attr("checked") != "checked") {
                    return;
                }
            }
            var key = $hidden.data('attribute-name');
            if ($hidden.attr("type") == "checkbox") {
                data[key] = ($hidden.attr("checked") == "checked");
                return;
            }
            var defVal = $hidden.data('defaultValue');
            var decimal = number_1.extractFieldAsDecimal($hidden);
            var fieldVal = typeof decimal === 'number' ? decimal : $hidden.val();
            if (fieldVal || typeof fieldVal === 'number') {
                data[key] = fieldVal;
            }
            else {
                data[key] = data[key] || defVal;
            }
        });
        if (data.skipWindowMeasurement) {
            var unsetMeasures = windowMeasurementAttrs;
            ;
            $.each(unsetMeasures, function (i, k) {
                var n = data[k] ? k : "window" + k;
                if (data[n])
                    data[k] = undefined;
            });
        }
        if (typeof productType === 'number') {
            data.productType = productType;
        }
        data.valanceWidth = data.valanceWidth || data.width;
        data.panelWidth = data.panelWidth || Math.min(100, data.width);
        data.panelHeight = data.panelHeight || data.height;
        data.panelFabricGrade = data.panelFabricGrade || data.fabricGrade;
        data.windowType = data.windowType || 0;
        data.sideWidth = data.sideWidth || 40;
        if (data.matchingFabricId > 0 && data.fabric2_CodeName === undefined && renderCustomValance_1.defaultWithMatchingFabric(data.styleIndex)) {
            data.fabric2_CodeName = $("img.asset[data-asset_id=\"" + data.matchingFabricId + "\"]").attr("codename");
        }
        if (data.fabric2Id) {
            data.fabricDiscount = 0;
        }
        return data;
    }
    exports.getAttributesFromForm = getAttributesFromForm;
    function updateDataBound($fld) {
        if ($fld) {
            var controlId = $fld.data('attribute-id');
            if (controlId) {
                var bound = $("[data-bind=\"" + controlId + "\"]");
                bound.text(number_1.extractFieldAsDecimal($fld));
            }
        }
        else {
            $('*[data-bind]').each(function (i, s) {
                var $t = $(s);
                var controlId = $t.data('bind');
                var $from = $("*[data-attribute-id=\"" + controlId + "\"]");
                $t.text(number_1.extractFieldAsDecimal($from));
            });
        }
    }
    exports.updateDataBound = updateDataBound;
    var selectedProductType = function () {
        return number_1.valAsNumber($('.selected[data-product-type').data('product-type'));
    };
    function attributesMatchProductPicture() {
        var $width = $('*[data-attribute-name="width"]');
        var $fabric = $('input[data-attribute-name="fabricId"]');
        var $fringeColor = $('*[data-attribute-name="fringeColor"]');
        var originalProductType = number_1.extractFieldAsDecimal($('input#pictureProductType'));
        var preselectedProductType = originalProductType !== undefined && originalProductType === selectedProductType();
        var preSelectedWidth = "" + $width.data('attribute-pre-selected') === $width.val();
        var preSelectedFabric = "" + $fabric.data('attribute-pre-selected') === $fabric.val();
        var preSelectedFringe = $fringeColor.length === 0 || "" + $fringeColor.data('attribute-pre-selected') == $fringeColor.val();
        return preSelectedWidth && preSelectedFabric && preselectedProductType && preSelectedFringe;
    }
    exports.attributesMatchProductPicture = attributesMatchProductPicture;
    function aggregatePricing(pricings) {
        return pricings.reduce(function (c, p) {
            for (var _i = 0, _a = Object.keys(p); _i < _a.length; _i++) {
                var k = _a[_i];
                if (k.endsWith('Cost') || k.endsWith('Original')) {
                    c[k] = (c[k] || 0) + p[k];
                }
                else {
                    c[k] = c[k] || p[k];
                }
            }
            return c;
        }, {});
    }
    function computeFormulaPricing(api, name, data) {
        data['id'] = 0;
        data['name'] = name;
        var def = $.Deferred();
        $.post(api, data).then(function (r) {
            var result = r.result;
            if (Array.isArray(result)) {
                def.resolve(aggregatePricing(result));
            }
            else {
                def.resolve(result);
            }
        }, function (e) {
            def.reject(e);
        });
        return def;
    }
    exports.computeFormulaPricing = computeFormulaPricing;
    function updateSwagPriceWithFormula(postUrl, formulaName) {
        var data = getAttributesFromForm();
        if (!data['width']) {
            return;
        }
        if (!assetPicker_1.hasValidAsset('fabricId')) {
            return;
        }
        if (!formulaName) {
            return;
        }
        if (data['hasFringe'] !== undefined) {
            data['hasFringe'] = data['fringeColor'] ? 1 : 0;
        }
        computeFormulaPricing(postUrl, formulaName, data)
            .then(function (pricing) {
            if (pricing && pricing.Item1) {
                pricing.swagCount = pricing.Item1;
                pricing.totalProductCost = pricing.Item2;
            }
            else {
                showPricingFromFormula(pricing);
            }
            $('.attribute-button.missing').toggleClass('missing', false);
            $('.pricing-attrs').toggleClass('masked-pricing-attrs', false);
            $('.prompt-missing-attrs').toggleClass('masked-missing-attrs', true);
            $('.on-required-attr').toggleClass('missing-required-attrs', false);
            addressBar_1.setHashFromData(data);
        }).fail(function () {
            $('.pricing-attrs').toggleClass('masked-pricing-attrs', true);
            $('.prompt-missing-attrs').toggleClass('masked-missing-attrs', false);
            $('.on-required-attr').toggleClass('missing-required-attrs', true);
        });
    }
    exports.updateSwagPriceWithFormula = updateSwagPriceWithFormula;
    function initPriceSheetQuantity(id) {
        $('.product-price-sheet .product-price-offer').each(function () {
            var $variant = $(this);
            var match = $variant.attr('id') == id;
            $variant.find('.quantity select').val(match ? 1 : 0);
            var $opt = $variant.closest('.option');
            $opt.toggleClass('selected', match);
            $variant.find('.quantity input[type="hidden"]').val(match ? 1 : 0);
            if (match) {
                $variant.fin;
            }
            if (match) {
                $('#ProductType').val($opt.data('product-type')).trigger('change');
            }
        });
    }
    exports.initPriceSheetQuantity = initPriceSheetQuantity;
    function watchForChange(sel, watch) {
        var $button = $(sel);
        var $watch = $(watch);
        var curVal = number_1.extractFieldAsDecimal($watch);
        if (curVal < 0) {
            $button.prop('disabled', 'disabled');
        }
        else {
            $button.removeProp('disabled');
        }
        $watch.change(function () {
            var val = parseInt($watch.val());
            if (val < 0) {
                $button.prop('disabled', 'disabled').val('Sold out');
            }
            else {
                $button.val('Add to cart');
                $button.removeProp('disabled');
            }
        });
    }
    exports.watchForChange = watchForChange;
    function setupFormulaAddToCart(sel, postUrl, formulaResult) {
        $(sel).click(function (e) {
            e.preventDefault();
            analytics_1["default"]('cart', 'addProduct');
            if (!assetPicker_1.hasValidAsset('fabricId')) {
                if (context_1["default"].isMobile()) {
                    ajaxCart_1.markMissingAttributes(['fabricId']);
                }
                else {
                    notifications_1.displayBarNotification('No fabric selected', 'error', 0);
                }
                return;
            }
            var $variants = $('.product-price-sheet .product-price-offer');
            $variants = $variants.filter(function (i) {
                var $variant = $(this);
                return $variant.find('.quantity select, .quantity input[type="hidden"]').val() > 0;
            });
            var $detail = $('input:hidden[data-attribute-name="Product"]');
            var postData = {};
            var imageFile = null;
            var deferred = $.Deferred();
            $variants.each(function (i, v) {
                var $variant = $(v);
                var $fringeColor = $('.attributes select[data-attribute-name="fringeColor"]');
                var fringeColorValue = 0;
                if ($fringeColor.length) {
                    fringeColorValue = parseInt($fringeColor.val());
                }
                else {
                    $fringeColor = $('.attributes input[data-attribute-name="fringeColor"]');
                    fringeColorValue = $fringeColor.val();
                }
                $('input[data-attribute-name="hasFringe"]').val(fringeColorValue ? "1" : "0");
                $detail.val($variant.next('.product-offer-detail').find('.info').text().trim());
                var $inputs = $variant.find('.quantity select')
                    .add($variant.closest('.option').find('.quantity input[type="hidden"]'))
                    .add($('.attributes input[value]').not('#' + formulaResult))
                    .add($('.attributes select'))
                    .add($('.attributes input[type="number"][data-attribute-id]:not(*[data-sync])'))
                    .add($('.attributes input[type="range"][data-attribute-id]:not(*[data-sync])'))
                    .add($("<input type='hidden'/>").attr('name', formulaResult)
                    .val($variant.data('attribute-value')));
                var hash = {};
                $inputs.each(function (i, input) {
                    var $input = $(input);
                    var name = $input.attr('name');
                    var attrName = $input.data('attribute-name');
                    var hasValue = !!$input.val();
                    if (attrName == 'fabricDiscount') {
                        return;
                    }
                    if (name && !hash[name] && hasValue) {
                        hash[name] = input;
                    }
                    if (attrName && !hash[attrName] && hasValue) {
                        hash[attrName] = input;
                    }
                });
                hash.valanceWidth = hash.valanceWidth || hash.width;
                if (!hash.panelWidth) {
                    hash.panelWidth = $("<input type=\"hidden\" name='panelWidth' value=\"" + Math.min(100, $(hash.width).val()) + "\"/>")[0];
                }
                if (!hash.windowType) {
                    hash.windowType = $("<input type='hidden' name='windowType' value='0'/>")[0];
                }
                if (!hash.sideWidth) {
                    hash.sideWidth = $("<input type='hidden' name='sideWidth' value='40'/>")[0];
                }
                hash.panelHeight = hash.panelHeight || hash.height;
                hash.panelFabricGrade = hash.panelFabricGrade || hash.fabricGrade;
                $inputs = $($.unique($.map(hash, function (v) { return v; })));
                hash = {};
                $inputs = $inputs.filter(function (i, input) {
                    var name = $(input).attr('name');
                    if (name && hash[name]) {
                        return false;
                    }
                    else if (name) {
                        hash[name] = input;
                    }
                    return true;
                });
                postData['add_to_cart_formula_' + $variant.attr('id')] = $inputs.serialize();
                postData['forceCartItemImageUrl'] = !attributesMatchProductPicture();
            });
            addFormulaProductToCart(postUrl, postData, renderCustomValance_1.tryRenderCartImage);
        });
    }
    exports.setupFormulaAddToCart = setupFormulaAddToCart;
    function addFormulaProductToCart(postUrl, postData, renderImage) {
        var xhr = ajaxCart_1.AjaxCart.instance().addProductVariantsToCart(postUrl, postData, null);
        if (settings_1._settings.renderCartImage) {
            xhr.then(renderImage)
                .then(function (cartImageFile) {
                if (cartImageFile) {
                    ajaxCart_1.AjaxCart.instance().addProductVariantsToCart(postUrl, postData, cartImageFile);
                }
            });
        }
    }
    exports.addFormulaProductToCart = addFormulaProductToCart;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/priceFormula.js
// module id = 27
// module chunks = 0